import React, { useCallback, useEffect, useState } from "react";

import {
  incidentTypes,
  lowSeverities,
  highSeverities,
  staffType,
  STAFFEMPLOYER,
  INCIDENTTYPESEVERITY_4_5,
} from "../../CONSTANTS";
import { Col, Popover, Row } from "react-bootstrap";
import CustomDatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import moment from "moment";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import FormDateTimePicker from "app/Components/_form/FormDatePicker/FormDateTimePicker";
import { ButtonsContainer, permitShifts } from "../../IncidentReportForm";
import FormInput from "app/Components/_form/FormInput/FormInput";
import { getArraayofKeys, IS_USER_SITE_MINES } from "../../Helper";
import { BsFillInfoCircleFill } from "react-icons/bs";
import CustomTooltip from "../../../../../Components/CommanComponents/CustomTooltip";
import CustomPopover from "app/Components/CommanComponents/CustomPopover";
import { currentHoursMiuntes } from "app/_helpers/helper";

function IncidentInfoTab({
  form = {},
  onChange,
  error = {},
  onChangeDate,
  sites,
  countries,
  states = [],
  departments,
  setTab,
  onSubmit,
  area,
  subArea,
  activity,
  subActivity,
  users,
  disableEmployer,
  contractors,
  contractorsStaff,
  employeeList,
}) {
  const [hoursMinutes, setHoursMinutes] = useState({});
  const checkForSeverity = () => {
    if (INCIDENTTYPESEVERITY_4_5.includes(form?.type)) {
      return true;
    }
    return false;
  };

  const [isStaffVisible, setIsStaffVisible] = useState(false);
  const [isStaffTextBox, setIsStaffTextBox] = useState(false);
  const [showSubAreaText, setShowSubAreaTex] = useState(false);

  // useEffect(() => {
  //   setHoursMinutes(currentHoursMiuntes(form.incidentDate));
  //   console.log("formattt", currentHoursMiuntes(form.incidentDate));
  // }, [form.incidentDate]);

  // console.log("hoursMinutes", hoursMinutes);

  useEffect(() => {
    if (parseInt(form.subAreaId) === 999) {
      setShowSubAreaTex(true);
    } else {
      setShowSubAreaTex(false);
    }
  }, [form.subAreaId]);
  // console.log("/*/**/*/staffType", form?.staffType);
  useEffect(() => {
    // Conditions
    if (form.staffType === "contractor") {
      setIsStaffVisible(true);
      setIsStaffTextBox(false);
    } else if (form.staffType === "employee") {
      setIsStaffVisible(true);
      setIsStaffTextBox(false);
    } else if (form.staffType === "others") {
      setIsStaffTextBox(true);
      setIsStaffVisible(false);
    } else {
      setIsStaffVisible(true);
      setIsStaffTextBox(false);
    }
  }, [form.staffType]);
  return (
    <div className="card p-3 pb-0 mt-3">
      <div className="d-flex justify-content-between simple-card-title">
        <h3 class="text-capitalize mb-0">Incident Info</h3>
        {form.incidentId && (
          <div className="mr-3">
            <label>Incident ID: {form.incidentId}</label>
          </div>
        )}
      </div>
      {/* {console.log("department values ",departments)} */}
      <div className="ehsFormWrapper">
        {/* {console.log("+++++++++++chedckkkkkk", currentHoursMiuntes())} */}
        <Row>
          <Col lg={4}>
            <FormSelect
              label={"Incident Type"}
              name="type"
              value={form?.type}
              onChange={onChange}
              options={getArraayofKeys(incidentTypes)}
              object={incidentTypes}
              error={error?.type}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            <div className="form-group">
              <label>
                Incident Severity{" "}
                <CustomPopover
                  placement={"right"}
                  tooltip={
                    <>
                      <table className="table table-bordered tooltipTable">
                        <thead>
                          <tr>
                            <th>Incident Severity</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {highSeverities.map((x) => {
                            return (
                              <tr>
                                <td>{x.label}</td>
                                <td>{x.tooltip}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </>
                  }
                >
                  <BsFillInfoCircleFill />
                </CustomPopover>
              </label>
              <FormSelect
                name="severity"
                value={form?.severity}
                onChange={onChange}
                options={checkForSeverity() ? highSeverities : lowSeverities}
                error={error?.severity}
                KEY_value={"value"}
              ></FormSelect>
            </div>
          </Col>
          <Col lg={4}>
            <div className="form-group">
              <label>Incident Date and Time</label>
              <CustomDatePicker
                isValidDate={(day) => day.isBefore(moment())}
                value={
                  form.incidentDate
                    ? form.incidentDate
                    : moment().format("YYYY-MM-DD HH:mm")
                }
                name="incidentDate"
                onChange={onChangeDate}
                timeFormat={"HH:mm A"}
                dateFormat="YYYY-MM-DD"
                // timeConstraints={hoursMinutes}
              />
              <span className="small text-danger">{error.incidentDate}</span>
            </div>
          </Col>
          <Col lg={4}>
            {/* <div className="form-group">
              <label>Report Date and Time</label>
              <CustomDatePicker
                isValidDate={(day) =>
                  day.isBefore(moment()) &&
                  day.isAfter(moment(form.incidentDate).add(-1, "days"))
                }
                value={form.reportDate}
                name="reportDate"
                onChange={onChangeDate}
                timeFormat={"HH:mm:ss"}
                dateFormat="YYYY-MM-DD"
              />
              <span className="small text-danger">{error.reportDate}</span>
            </div> */}

            <FormDateTimePicker
              isValidDate={(day) =>
                day.isBefore(moment()) &&
                day.isAfter(moment(form.incidentDate).add(-1, "days"))
              }
              value={
                form.reportDate ? form.reportDate : moment().format("YYYY-MM-DD HH:mm")
              }
              name="reportDate"
              onChange={onChangeDate}
              timeFormat={"HH:mm A"}
              dateFormat="YYYY-MM-DD"
              label={"Report Date and Time"}
              error={error?.reportDate}
            />
          </Col>
          <Col lg={4}>
            {/* <div className="form-group">
              <label>Incident - Site Name</label>

              <SimpleSelect
                name="siteId"
                value={form.siteId}
                onChange={onChange}
                
                disabled={!!params.siteId}
                id="id"
                label="name"
                options={sites}
                init="Select"
              ></SimpleSelect>

              <span className="small text-danger">{error.siteId}</span>
            </div> */}
            <FormSelect
              label={"Incident - Location Name"}
              name="siteId"
              value={form?.siteId}
              onChange={onChange}
              options={sites}
              error={error?.siteId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
              disabled={IS_USER_SITE_MINES()}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            <FormInput
              readOnly={true}
              name="roId"
              value={form.roName}
              type="text"
              label={"Incident - Regional Office"}
              error={error?.roId}
            />
            <FormInput
              readOnly={true}
              name="roId"
              value={form.roId}
              type="hidden"
              error={error?.roid}
            />
          </Col>
          <Col lg={4}>
            <FormSelect
              label={"Reported By - Staff Type"}
              name="staffType"
              value={form?.staffType}
              onChange={onChange}
              options={getArraayofKeys(staffType)}
              object={staffType}
              error={error?.staffType}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            {isStaffTextBox === true ? (
              <FormInput
                label={`Reported by - ${
                  form?.staffType ? staffType[form?.staffType] : staffType.employee
                } Staff Name`}
                name="otherStaffName"
                value={form?.otherStaffName}
                onChange={onChange}
                error={error?.otherStaffName}
                KEY_label={"firstName"}
                KEY_value={"id"}
              ></FormInput>
            ) : null}
            {isStaffVisible === true ? (
              <FormSelect
                label={`Reported by - ${
                  form?.staffType ? staffType[form?.staffType] : staffType.employee
                } Staff Name`}
                name="staffName"
                value={form?.staffName}
                onChange={onChange}
                options={!disableEmployer ? contractorsStaff : employeeList}
                error={error?.staffName}
                KEY_label={
                  !disableEmployer ? "name_aadharNumber_srNo" : "name_email_employeeId"
                }
                disabled={!form?.staffType ? true : false}
                placeholder={
                  !disableEmployer
                    ? "Search by Name / Aadhar No / Sr No."
                    : "Search by Name / Email Id / Employee Id"
                }
                KEY_value={"id"}
                blankSelect={"none"}
              ></FormSelect>
            ) : (
              false
            )}
          </Col>
          <Col lg={4}>
            <FormSelect
              label={`Reported by - ${
                form?.staffType ? staffType[form?.staffType] : staffType.employee
              } ${form?.staffType === "contractor" ? "- Entity Name" : ""}`}
              name="staffEmployer"
              value={disableEmployer ? form?.staffEmployer : +form?.staffEmployer}
              onChange={onChange}
              options={disableEmployer ? STAFFEMPLOYER : contractors}
              error={error?.staffEmployer}
              KEY_label={disableEmployer ? "contactPerson" : "contractorLegalEntity"}
              KEY_value={"id"}
              blankSelect={"Select"}
              disabled={true}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            <FormSelect
              label={"Area"}
              name="areaId"
              value={form?.areaId}
              onChange={onChange}
              options={area}
              error={error?.areaId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            <FormSelect
              label={"Sub Area"}
              name="subAreaId"
              value={+form?.subAreaId}
              onChange={onChange}
              options={subArea}
              error={error?.subAreaId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            {showSubAreaText && (
              <FormInput
                label={"Other Sub Area"}
                name="otherSubArea"
                value={form?.otherSubArea}
                onChange={onChange}
                error={error?.otherSubArea}
                KEY_label={"name"}
                KEY_value={"id"}
              ></FormInput>
            )}
          </Col>
          <Col lg={4}>
            {/* <div className="form-group">
              <label>Select Shift </label>

              <SimpleSelect
                
                name="shift"
                value={form.shift}
                onChange={onChange}
                options={Object.values(permitShifts)}
                array={"single"}
              ></SimpleSelect>

              <span className="small text-danger">{error.shift}</span>
            </div> */}

            <FormSelect
              label={"Shift"}
              name="shift"
              value={form?.shift}
              onChange={onChange}
              options={Object.values(permitShifts)}
              array={"single"}
              error={error?.shift}
              blankSelect={"Select"}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            <FormSelect
              label={"Activity"}
              name="activityId"
              value={form?.activityId}
              onChange={onChange}
              options={activity}
              error={error?.activityId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            <FormSelect
              label={"Sub Activity"}
              name="subActivityId"
              value={+form?.subActivityId}
              onChange={onChange}
              options={subActivity}
              error={error?.subActivityId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
            ></FormSelect>
          </Col>
          <Col lg={4}>
            <FormSelect
              label={"Department"}
              name="departmentId"
              value={form?.departmentId}
              onChange={onChange}
              options={departments}
              error={error?.departmentId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
            ></FormSelect>
          </Col>

          <Col lg={4}>
            <FormInput
              label={"Location ID"}
              name="locationSiteId"
              value={form?.locationSiteId}
              onChange={onChange}
              readOnly={true}
              type="text"
            ></FormInput>
            {/* <FormSelect
              label={"Location ID"}
              name="siteSiteId"
              value={form?.siteSiteId}
              onChange={onChange}
              options={sites}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
              disabled
            ></FormSelect> */}
          </Col>
          <Col lg={4}>
            <FormInput
              label={"RO ID"}
              name="roSiteId"
              value={form?.roSiteId}
              onChange={onChange}
              readOnly={true}
              type="text"
            ></FormInput>
          </Col>
          {/* <Col lg={4}>
            <FormSelect
              label={"SMS Time Stamp"}
              name="siteSiteId"
              value={form?.siteSiteId}
              onChange={onChange}
              options={sites}
              error={error?.siteSiteId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
            ></FormSelect>
          </Col> */}

          <Col lg={4}>
            {/* <div className="form-group">
              <label>Country</label>

              <SimpleSelect
                disabled={!form.siteId || (form.siteId && form.countryMasterId)}
                name="countryMasterId"
                value={form.countryMasterId}
                onChange={onChange}
                
                id="id"
                label="name"
                options={countries}
                init="Select"
              ></SimpleSelect>
              <span className="small text-danger">{error.countryMasterId}</span>
            </div> */}
            <FormSelect
              label={"Country"}
              name="countryMasterId"
              value={form?.countryMasterId}
              onChange={onChange}
              options={countries}
              error={error?.countryMasterId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
              disabled
            ></FormSelect>
          </Col>
          <Col lg={4}>
            {/* <div className="form-group">
              <label>State</label>
              <select
                disabled={!form.siteId || (form.siteId && form.stateMasterId)}
                name="stateMasterId"
                value={form.stateMasterId}
                onChange={onChange}
                
              >
                <option value="">Select</option>
                {states
                  .filter(
                    (state) => state.countryMasterId === +form.countryMasterId
                  )
                  .map((state, index) => (
                    <option key={index} value={state.id}>
                      {state.name}
                    </option>
                  ))}
              </select>
              <span className="small text-danger">{error.stateMasterId}</span>
            </div> */}
            <FormSelect
              label={"State"}
              name="stateMasterId"
              value={form?.stateMasterId}
              onChange={onChange}
              options={states.filter(
                (state) => state.countryMasterId === +form.countryMasterId
              )}
              error={error?.stateMasterId}
              KEY_label={"name"}
              KEY_value={"id"}
              blankSelect={"Select"}
              disabled
            ></FormSelect>
          </Col>
        </Row>
      </div>
      <ButtonsContainer
        incidentStatus={form.incidentStatus}
        setTab={setTab}
        closeIncident={form.closeIncident}
        next={2}
        onSubmit={onSubmit}
        noBack
      />
    </div>
  );
}

export default IncidentInfoTab;
